import { formatPatientPrimaryName } from "./helpers/formatCrmCommunicationsDisplay";
import type { CrmPatientSummary } from "./types";

/** Nome formatado para listas, tooltips e `aria-label`. */
export function formatPatientListLabel(p: CrmPatientSummary): string {
  return formatPatientPrimaryName(p.usualName, p.officialName);
}
